module.exports = __webpack_public_path__ + "images/ic-tower_and_wxwork_2-f795c76c7c6ce0579aa2b4f1dabd0352.png";